var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback } from 'react';
import { useApiDelete } from '@sierralabs/core-ui';
export function useTruncateEntity(id) {
    const _a = useApiDelete(`entities/${id}/truncate`), { del, isLoading, error } = _a, result = __rest(_a, ["del", "isLoading", "error"]);
    const truncate = useCallback((cascade = false) => {
        del({ cascade });
    }, [del]);
    return Object.assign(Object.assign({}, result), { isTruncating: isLoading, truncateError: error, truncate });
}
//# sourceMappingURL=useTruncateEntity.js.map